<ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
